(function () {
  'use strict';

  var SECTION_TYPE = 'aaa-pdp-actions-for-has-sizes';

  var sel = {
    variantSelector: '[data-variant-selector]',
    variantOption: '[data-variant-option]',
    variantData: '[data-variant-data]',
    finishesContainer: '[data-finishes-container]',
    productForm: '[data-product-form]',
    productId: '.pdp__product-id',
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    addToCartPrice: '[data-add-to-cart-price]',
    notifyForm: '[data-notify-form]',
    finishSelect: '[data-finish-select]',
    finishAddonTrigger: '[data-finish-addon-trigger]',
    dryMountTrigger: '[data-finish-dry-mounted-trigger]',
    customFinishId: '[data-custom-finish-id]',
    customFinish: '[data-custom-finish]',
    customFinishPrice: '[data-custom-finish-price]',
    customFinishAddon: '[data-custom-finish-addon]',
    customFinishAddonId: '[data-custom-finish-addon-id]',
    sizesOption: '.pdp__variant',
  };

  var abortController = null;
  var variants = [];

  // -- Helpers --------------------------------------------------------------

  function getCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  function removeCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  }

  function formatMoney(cents, includeCode) {
    var sym = document.body.getAttribute('data-shop-currency-symbol') || '$';
    var currency = document.body.getAttribute('data-shop-currency') || 'USD';
    var format = includeCode !== false
      ? sym + '{{amount}} ' + currency
      : sym + '{{amount}}';
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, format);
    }
    var amount = (cents / 100).toFixed(2);
    return includeCode !== false ? sym + amount + ' ' + currency : sym + amount;
  }

  function getVariantById(id) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) return variants[i];
    }
    return null;
  }

  // -- Button / price state -------------------------------------------------

  function renderButton(variant) {
    var btn = document.querySelector(sel.addToCart);
    var textEl = document.querySelector(sel.addToCartText);
    var priceEl = document.querySelector(sel.addToCartPrice);
    var notifyForm = document.querySelector(sel.notifyForm);
    if (!btn || !textEl || !priceEl) return;

    if (!variant || !variant.available) {
      btn.disabled = true;
      btn.classList.add('disabled');
      textEl.textContent = variant ? 'Sold Out' : 'Unavailable';
      priceEl.textContent = '';
      if (notifyForm) notifyForm.classList.remove('hide');
    } else {
      btn.disabled = false;
      btn.classList.remove('disabled');
      textEl.textContent =
        (window.theme && window.theme.strings && window.theme.strings.addToCart) || 'Add to Cart';
      priceEl.innerHTML = formatMoney(variant.price);
      if (notifyForm) notifyForm.classList.add('hide');
    }

    updateHeaderPrice(variant);
  }

  function updateHeaderPrice(variant) {
    var currentEl = document.querySelector('.c-pdpMain__price .b-price__current');
    var originalEl = document.querySelector('.c-pdpMain__price .b-price__original');
    if (!currentEl) return;

    if (variant) {
      currentEl.innerHTML = formatMoney(variant.price, false);
    }

    if (originalEl) {
      if (variant && variant.compareAtPrice > variant.price) {
        originalEl.innerHTML = formatMoney(variant.compareAtPrice, false);
        originalEl.style.display = '';
      } else {
        originalEl.style.display = 'none';
      }
    }
  }

  // -- Finish state capture / restore ---------------------------------------

  function captureFinishState() {
    var selected = document.querySelector(sel.finishSelect + '.selected');
    if (!selected) return null;

    var addonTrigger = document.querySelector(sel.finishAddonTrigger);
    var dryMountTrigger = document.querySelector(sel.dryMountTrigger);

    return {
      handle: selected.getAttribute('data-frame-handle'),
      variantTitle: selected.getAttribute('data-variant-title'),
      addonActive: !!(addonTrigger && addonTrigger.classList.contains('is-active')),
      dryMountOff: !!(dryMountTrigger && !dryMountTrigger.classList.contains('is-active')),
    };
  }

  function clearFinishState() {
    removeCookie('finish_type');
    removeCookie('finish_price');
    removeCookie('finish_code');

    [sel.customFinishId, sel.customFinish, sel.customFinishPrice,
     sel.customFinishAddon, sel.customFinishAddonId].forEach(function (s) {
      var el = document.querySelector(s);
      if (el) el.value = '';
    });
  }

  function restoreFinishState(state, variant) {
    if (!state || !state.handle) return;

    var container = document.querySelector(sel.finishesContainer);
    if (!container) return;

    var match = state.variantTitle
      ? container.querySelector(
          sel.finishSelect +
          '[data-frame-handle="' + state.handle + '"]' +
          '[data-variant-title="' + state.variantTitle + '"]'
        )
      : null;

    if (!match) {
      match = container.querySelector(
        sel.finishSelect + '[data-frame-handle="' + state.handle + '"]'
      );
    }

    if (match && !match.classList.contains('unavailable')) {
      match.click();

      if (state.addonActive) {
        var addonTrigger = document.querySelector(sel.finishAddonTrigger);
        if (addonTrigger && !addonTrigger.classList.contains('is-active')) {
          addonTrigger.click();
        }
      }

      if (state.dryMountOff) {
        var dryMountTrigger = document.querySelector(sel.dryMountTrigger);
        if (dryMountTrigger && dryMountTrigger.classList.contains('is-active')) {
          dryMountTrigger.click();
        }
      }
    } else {
      clearFinishState();
      renderButton(variant);
    }
  }

  // -- Section Rendering API ------------------------------------------------

  async function fetchFinishes(productHandle, variantId) {
    if (abortController) abortController.abort();
    abortController = new AbortController();

    var container = document.querySelector(sel.finishesContainer);
    if (!container) return false;

    container.classList.remove('s-hasFailed');
    container.classList.add('s-isLoading');

    var url = '/products/' + productHandle + '?variant=' + variantId + '&sections=' + SECTION_TYPE;
    var maxAttempts = 3;

    try {
      for (var attempt = 1; attempt <= maxAttempts; attempt++) {
        var response = await fetch(url, { signal: abortController.signal });

        if (response.status === 429) {
          if (attempt < maxAttempts) {
            await new Promise(function (r) { setTimeout(r, 1000 * attempt); });
            continue;
          }
          container.classList.add('s-hasFailed');
          return false;
        }

        if (!response.ok) {
          container.classList.add('s-hasFailed');
          return false;
        }

        var data = await response.json();
        var html = data[SECTION_TYPE];
        if (!html) {
          container.classList.add('s-hasFailed');
          return false;
        }

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newContainer = doc.querySelector(sel.finishesContainer);
        if (newContainer) container.innerHTML = newContainer.innerHTML;
        return true;
      }
    } catch (e) {
      if (e.name === 'AbortError') return false;
      container.classList.add('s-hasFailed');
    } finally {
      container.classList.remove('s-isLoading');
    }
    return false;
  }

  // -- Variant change -------------------------------------------------------

  function updateVariantSelector(variantId) {
    document.querySelectorAll(sel.sizesOption).forEach(function (label) {
      var input = label.querySelector('input');
      label.classList.toggle('is-active', !!(input && parseInt(input.value, 10) === variantId));
    });
  }

  async function onVariantChange(variantId) {
    var variant = getVariantById(variantId);
    if (!variant) return;

    var finishState = captureFinishState();

    var form = document.querySelector(sel.productForm);
    if (form) {
      form.setAttribute('data-price', variant.price);
      form.setAttribute('data-compare-price', variant.compareAtPrice);
      form.setAttribute('data-variant-id', variant.id);
    }

    var idInput = document.querySelector(sel.productId);
    if (idInput) idInput.value = variant.id;

    var dimInput = document.querySelector('#dimensions');
    if (dimInput) dimInput.value = variant.width + ' x ' + variant.height;

    var invInput = document.querySelector('#productInventory');
    if (invInput) invInput.value = variant.inventoryQuantity;

    updateVariantSelector(variantId);

    if (finishState) clearFinishState();

    renderButton(variant);

    var productHandle = form ? form.getAttribute('data-product-handle') : null;
    if (!productHandle) return;

    var fetchOk = await fetchFinishes(productHandle, variantId);

    if (fetchOk && finishState) {
      restoreFinishState(finishState, variant);
    } else if (!fetchOk && finishState) {
      clearFinishState();
      renderButton(variant);
    }
  }

  // -- Init -----------------------------------------------------------------

  document.addEventListener('DOMContentLoaded', function () {
    var dataEl = document.querySelector(sel.variantData);
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    }

    var selectorContainer = document.querySelector(sel.variantSelector);
    if (!selectorContainer) return;

    selectorContainer.addEventListener('change', function (e) {
      if (!e.target.matches(sel.variantOption)) return;
      var variantId = parseInt(e.target.value, 10);
      if (variantId) onVariantChange(variantId);
    });
  });
})();
